<template>
  <div style="height: 100%">
    <div v-if="loginSetting.supportPic" class="support-pic"><img :src="loginSetting.supportPic" /></div>
    <sidebar class="sidebar-container el-scrollbar"></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import AppMain from './components/AppMain'
import Sidebar from './components/Sidebar'
import Navbar from './components/Navbar'
import {mapGetters} from 'vuex'

export default {
  name: 'layout',
  computed: {
    ...mapGetters(['loginSetting'])
  },
  components: {
    AppMain,
    Sidebar,
    Navbar
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
  .support-pic {
    position: fixed;
    left: 90px;
    bottom: 30px;
    transform: translateX(-50%);
    z-index: 9999;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue